var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReplay = function SvgReplay(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6C11 5.44772 11.4477 5 12 5C16.4183 5 20 8.58172 20 13C20 17.4183 16.4183 21 12 21C7.58172 21 4 17.4183 4 13C4 12.4477 4.44772 12 5 12C5.55228 12 6 12.4477 6 13C6 16.3137 8.68629 19 12 19C15.3137 19 18 16.3137 18 13C18 9.68629 15.3137 7 12 7C11.4477 7 11 6.55228 11 6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.73703C12 4.09201 12 3.2695 11.4719 2.98684C10.9437 2.70419 10.2593 3.16044 8.8906 4.07293L8.49615 4.3359C7.36723 5.08851 6.80278 5.46482 6.80278 6C6.80278 6.53518 7.36723 6.91149 8.49615 7.6641L8.8906 7.92707C10.2593 8.83956 10.9437 9.29581 11.4719 9.01316C12 8.7305 12 7.90799 12 6.26297V5.73703Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReplay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "replay.22922bce45ab18befe1ab903c6e41294.svg";